import gql from "graphql-tag";

export const DeletePreRequest = gql`
  mutation DeletePreRequest($id: String!) {
    deletePreRequest(id: $id)
  }
`;
